import React from "react";
import "../../components/PetCrateQuantityList/PetCrateQuantityList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const PetCrateQuantityList = ({
  CrateQuantityResponse,
  setOpenProfile,
  setCrateSelObj,
  refreshData, // Receive the refresh function
}) => {
  // Group items by product name and region, and calculate total inventory
  const groupedItems = CrateQuantityResponse.reduce((acc, item) => {
    const crateTypeName = item.Crate_Type_Name;
    const regionName = item.Region_Name;
    const newInventory = parseInt(item.total_Inventory, 10);

    if (!acc[crateTypeName]) {
      acc[crateTypeName] = {
        regions: {},
        totalInventory: 0,
        isActive: item.Is_Active,
      };
    }

    if (!acc[crateTypeName].regions[regionName]) {
      acc[crateTypeName].regions[regionName] = {
        items: [],
        regionTotal: 0,
        isActive: item.Is_Active,
      };
    }

    const existingItemIndex = acc[crateTypeName].regions[regionName].items.findIndex(
      (i) => i.id === item.id
    );

    if (existingItemIndex !== -1) {
      const oldInventory = parseInt(
        acc[crateTypeName].regions[regionName].items[existingItemIndex]
          .total_Inventory,
        10
      );
      acc[crateTypeName].regions[regionName].regionTotal -= oldInventory;
      acc[crateTypeName].totalInventory -= oldInventory;
      acc[crateTypeName].regions[regionName].items.splice(existingItemIndex, 1);
    }

    acc[crateTypeName].regions[regionName].items.push(item);
    acc[crateTypeName].regions[regionName].regionTotal += newInventory;
    acc[crateTypeName].totalInventory += newInventory;

    return acc;
  }, {});

  const groupedItemsArray = Object.keys(groupedItems).map((key) => ({
    name: key,
    regions: Object.keys(groupedItems[key].regions).map((regionKey) => ({
      name: regionKey,
      items: groupedItems[key].regions[regionKey].items,
      regionTotal: groupedItems[key].regions[regionKey].regionTotal,
      isActive: groupedItems[key].regions[regionKey].isActive,
    })),
    totalInventory: groupedItems[key].totalInventory,
  }));



  function getStatusColor(status) {
    switch (status) {
      case true:
        return "#28A745"; // Green for active
      case false:
        return "#DC3545"; // Red for inactive
      default:
        return "white"; // Default color
    }
  }

  return (
    <div className="container-fluid">
      <div className="petCrateQuantityList">
        <table>
          <thead>
            <tr className="petCrateQuantityListHeading">
              <th>S No.</th>
              <th>Product Name</th>
              <th>Total Inventory</th>
              <th>Region</th>
              <th>Region Total</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {groupedItemsArray.length > 0 ? (
              groupedItemsArray.map((group, groupIndex) =>
                group.regions.map((region, regionIndex) =>
                  region.items.map((item, index) => (
                    <tr key={item.Crate_Type_Id + index}>
                      {index === 0 && regionIndex === 0 && (
                        <>
                          <td
                            rowSpan={group.regions.reduce(
                              (acc, r) => acc + r.items.length,
                              0
                            )}
                          >
                            {groupIndex + 1}
                          </td>
                          <td
                            rowSpan={group.regions.reduce(
                              (acc, r) => acc + r.items.length,
                              0
                            )}
                          >
                            {group.name}
                          </td>
                          <td
                            rowSpan={group.regions.reduce(
                              (acc, r) => acc + r.items.length,
                              0
                            )}
                          >
                            {group.totalInventory}
                          </td>
                        </>
                      )}
                      {index === 0 && (
                        <>
                          <td rowSpan={region.items.length}>{region.name}</td>
                          <td rowSpan={region.items.length}>
                            {region.regionTotal}
                          </td>
                          <td
                            rowSpan={region.items.length}
                            style={{
                              color: region.isActive ? "#28A745" : "#DC3545",
                            }}
                          >
                            {region.isActive ? "Active" : "Inactive"}
                          </td>
                          <td rowSpan={region.items.length}>
                            <EditOutlinedIcon
                              onClick={() => {
                                setOpenProfile(true);
                                setCrateSelObj({
                                  Crate_Type_Id: item.Crate_Type_Id,
                                  Crate_Type_Name: group.name,
                                  Region_Name: region.name,
                                  total_Inventory: item.total_Inventory,
                                  Is_Active: item.Is_Active,
                                  RegionId: item.RegionId, // ensure RegionId is part of item object
                                });
                              }}
                              style={{ cursor: "pointer", marginRight: "10px" }}
                            />
                          
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                )
              )
            ) : (
              <tr>
                <td colSpan={7}>No Data Available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PetCrateQuantityList;
